import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Twitter } from 'lucide-react';

const TeamMember = ({
  name,
  role,
  bio,
  imageSrc,
  linkedin,
  twitter,
  delay = 0
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="glass-card overflow-hidden group"
      whileHover={{ 
        y: -5,
        boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
      }}
    >
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-dark-300 via-dark-300/50 to-transparent z-10"></div>
        <img 
          src={imageSrc} 
          alt={name} 
          className="w-full h-64 object-cover object-center transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute bottom-0 left-0 w-full p-6 z-20">
          <h3 className="text-xl font-bold mb-1 text-white">{name}</h3>
          <p className="text-primary-500 font-medium">{role}</p>
        </div>
      </div>
      <div className="p-6">
        <p className="text-gray-400 mb-4">{bio}</p>
        
        <div className="flex space-x-3">
          {linkedin && (
            <a 
              href={linkedin} 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 bg-dark-100 rounded-full text-gray-400 hover:bg-primary-500/20 hover:text-primary-500 transition-colors"
            >
              <Linkedin size={18} />
            </a>
          )}
          {twitter && (
            <a 
              href={twitter} 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 bg-dark-100 rounded-full text-gray-400 hover:bg-primary-500/20 hover:text-primary-500 transition-colors"
            >
              <Twitter size={18} />
            </a>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default TeamMember;
